export const ConfirmCancellationModal: string = 'ConfirmCancellationModal';
